<div class="wrapper">
  <div class="container-skipper">
    <h2>Descarga de archivos</h2>
    <h5 class="mb-2">Skipper-PJM</h5>

    <div class="upload-container">
      <div class="border-container letra">

        <hr>

        <div class="text-center">
          <div class="pb-1">
            <span>Número de Identificador</span>
          </div>
          <span style="margin-right: 5px;">cpl/</span>
          <input id="input" type="text" size="18" pInputText class="custom-inputtext" [(ngModel)]="idCode"
            (ngModelChange)="lookup($event)" autocomplete="off">
        </div>
        <hr>
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
            aria-valuenow="downProgressPercentage" aria-valuemin="0" aria-valuemax="100"
            [ngStyle]="{'width.%': downProgressPercentage}" style="background-color: rgb(25, 195, 125);">
            {{downProgressPercentage}}%</div>
        </div>


      </div>
    </div>

    <div class="doc-vid-borrado" *ngIf="docVidBorrado">
      EL DOCUMENTO O VIDEO FUE BORRADO
    </div>

    <div class="doc-vid-no-existente" *ngIf="shortIdDocVidInexistente">
      EL IDENTIFICADOR NO ES VALIDO
    </div>

    <div class="upload-container" *ngIf="showDocVidData">

      <div class="list-group">


        <li class="list-group-item" *ngFor="let file of lookedupFiles">
          <div class="container">
            <div class="row">
              <div class="col-4 d-inline-block text-truncate">
                <small class="mb-1">{{(file.archivo.length>35)? (file.archivo |
                  slice:0:35)+'..':(file.archivo)}}</small>
              </div>
              <div class="col">
                <small>{{file.fecha_guardado | date:'dd/MM/yy'}}</small>

              </div>
              <div class="col">
                <small p class="mb-1">{{file.formatted_name}} ({{file.size/1024/1024 | number}}MB)</small>

              </div>
              <div class="col">
                <small> {{file.tipo_archivo=='document'?'Documento':'Video'}}</small>

              </div>
              <div class="col">
                <fa-icon *ngIf="file.tipo_archivo!='video'" (mouseover)="file.hover_detail=true"
                  (mouseleave)="file.hover_detail=false" [icon]="faSearch"
                  [ngClass]="['icon-play', file.hover_copy ? 'hover_detail' : 'hover_detail_unselected']"
                  (click)="show_detail(file);open(content)">
                </fa-icon>

              </div>
              <div class="col">
                <fa-icon *ngIf="file.tipo_archivo=='video'" (mouseover)="file.hover_detail=true"
                  (mouseleave)="file.hover_detail=false" [icon]="faPlay"
                  [ngClass]="['icon-play', file.hover_copy ? 'hover_detail' : 'hover_detail_unselected']"
                  (click)="setupvideo(file);">
                </fa-icon>
                <fa-icon *ngIf="file.tipo_archivo!='video'" (mouseover)="file.hover_detail=true"
                  (mouseleave)="file.hover_detail=false" [icon]=" faArrowDown
            " [ngClass]="['icon-play', file.hover_copy ? 'hover_detail' : 'hover_detail_unselected']"
                  (click)="downloadSelected(file)"></fa-icon>
              </div>
            </div>
          </div>

          <div class="text-right">
          </div>

        </li>
        <li class="list-group-item" *ngIf="lookedupFiles.length > 1 &&  !hayVideos()">

          <div class="text-center">
            <h8 class="mb-1 ">Descargar Todo</h8>
            <small></small>
          </div>
          <div class="icons fa-4x">
            <a *ngIf="!creatingZip" [routerLink]="" (click)="download_all(lookedupFiles);">
              <fa-icon [icon]="faFileArchive" class="mr-1" size="xs"></fa-icon></a>
            <div *ngIf="creatingZip">
              <h5>Creando archivo comprimido...</h5>
            </div>
          </div>

        </li>
      </div>
    </div>
  </div>


  <ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title"><u>Detalle de Documento</u></h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group row">
          <label for="text1" class="col-4 col-form-label">.</label>
          <div class="col-8">
            <!-- {{(file.archivo.length>35)? (file.archivo | slice:0:35)+'..':(file.archivo)}} -->
            <span><strong>{{selectedFile.fileName_without_under || " "}}</strong></span>

          </div>
        </div>
        <div class="form-group row">
          <label for="text" class="col-4 col-form-label">Tamaño</label>
          <div class="col-8">
            <span><strong>{{selectedFile.size || " "}}</strong></span>
          </div>
        </div>
        <div class="form-group row">
          <label for="text2" class="col-4 col-form-label">Juzgado de Origen</label>
          <div class="col-8">
            <span><strong>{{selectedFile.descripcion_juzgado || " "}}</strong></span>
          </div>
        </div>
        <div class="form-group row">
          <label for="text3" class="col-4 col-form-label">Expediente / Legajo</label>
          <div class="col-8">
            <span><strong>{{selectedFile.numero_expediente || " "}}</strong></span>
          </div>
        </div>
        <div class="form-group row">
          <label for="text3" class="col-4 col-form-label">Tipo de Documento</label>
          <div class="col-8">
            <span><strong>{{selectedFile.tipo_acto || " "}}</strong></span>
          </div>
        </div>
        <div class="form-group row">
          <label for="text4" class="col-4 col-form-label">Visibilidad</label>
          <div class="col-8">
            <span><strong>{{selectedFile.condicion || " "}}</strong></span>
          </div>
        </div>
        <div class="form-group row">
          <label for="text3" class="col-4 col-form-label">Subido por</label>
          <div class="col-8">
            <span><strong>{{selectedFile.id_usuario || " "}}</strong></span>
          </div>
        </div>
        <div class="form-group row">
          <label for="text5" class="col-4 col-form-label">Relevancia</label>
          <div class="col-8">
            <span><strong>{{selectedFile.relevancia || " "}}</strong></span>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark"
        (click)="modal.close('Save click');downloadSelected(selectedFile)">Descargar Documento</button>
    </div>
  </ng-template>
  <hr>
  <!-- <app-vjs-player  #target [options]="{ autoplay: true, controls: true, sources: [{ src: '/path/to/video.mp4', type: 'video/mp4' }]}"></app-vjs-player> -->


  <!-- 
<div class='row'>
  <div class='col'>
    <app-player  *ngIf="signedURL!==''" [master]="signedURL"></app-player>
  </div>
</div> -->

  <p-dialog header="{{videoPlayerTitle}}" [resizable]='true' [(visible)]="display">
    <!-- <video  #target class="video-js"  ></video> -->
    <app-player *ngIf="signedURL!==''" [master]="signedURL" [fileName]="videoPlayerTitle"></app-player>
  </p-dialog>

  <!-- <button type="button" (click)="showDialog()" icon="pi pi-info-circle" label="Show">player</button> -->